import script from "./Invoices.vue?vue&type=script&setup=true&lang=ts"
export * from "./Invoices.vue?vue&type=script&setup=true&lang=ts"

import "./Invoices.vue?vue&type=style&index=0&id=3b95eb79&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b95eb79"]])

export default __exports__